import React from "react";
import { ModalFileName } from "@/shared/modals";

import { useModal } from "@/shared/utils/hooks/useModal";
import { Column, Row } from "@/shared/ui/Blocks";
import FileDropzone from "@/shared/ui/FileDropzone";
import { Title } from "@/shared/ui/Title";

interface FileUploadSectionProps {
  person_id?: number;
  position_id?: number;
  title?: string;
  subtitle?: string;
  description?: string;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  person_id,
  position_id,
  title,
  subtitle,
  description,
}) => {
  const [openAttachmentUpload] = useModal(ModalFileName.ATTACHMENT_UPLOAD, {
    person_id,
    position_id,
  });

  const handleFileSelect = (file: File) => {
    openAttachmentUpload({
      file,
    });
  };

  return (
    <Row className="p-8 w-full bg-gray-100 rounded-lg min-h-[200px] gap-8 print:hidden">
      <Column className="flex-1 justify-between py-4">
        <Row className="items-center gap-2">
          <Title as="h4" className="font-semibold">
            {title || "Make magic with AssessioAI"}
          </Title>
          <span className="text-xs text-primary bg-blue-100 rounded-lg px-2 py-1">
            IN BETA
          </span>
        </Row>
        <p className="text-sm text-gray-600">
          {subtitle ||
            "Upload interview notes, CVs, or other relevant documents."}
        </p>
        <p className="text-xs text-gray-600">
          {description ||
            "AssessioAI extracts key info to enrich the candidate’s pool of information. The insights are then added to the candidate’s evaluation sheet."}
        </p>
      </Column>
      <Column className="flex-1">
        <FileDropzone
          titleHidden
          onFileSelect={handleFileSelect}
          buttonLabel="Upload from file"
        />
      </Column>
    </Row>
  );
};

export default FileUploadSection;
